import { EventDispatcher } from "three"

export { Sizes }

class Sizes extends EventDispatcher {
    constructor() {
        super()
        window.addEventListener("resize", () => this.#resize(), { passive: true })
    }

    get x() {
        return document.documentElement.clientWidth
    }

    get y() {
        return document.documentElement.clientHeight
    }

    get ratio() {
        return Math.min(window.devicePixelRatio, 2)
    }

    get aspect() {
        return this.x / this.y
    }

    #resize() {
        this.dispatchEvent({
            type: "resize",
            x: this.x,
            y: this.y,
            ratio: this.ratio,
            aspect: this.aspect
        })
    }
}